import axios from "axios";

var SERVICE_URL =
  "https://nzthh0zab8.execute-api.ap-south-1.amazonaws.com/Prod";

export const CALL_API = async (action, method, payload) => {
  console.log(action, method, payload, "actionmethodpayload");
  const isMasterData = action.includes("master-data");
  try {
    const headers = {
      Tymeplusjwt: window.localStorage.getItem("token") || "",
    };

    if (!isMasterData) {
      headers["roleId"] = window.localStorage.getItem("selectedRoleId") || "";
    }
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers,
    });
    console.log(resp.data?.data, "FULLRESP");
    console.log(
      {
        method,
        url: `${SERVICE_URL}${action}`,
        data: payload,
        headers,
      },
      "respressswswpresp",
    );

    const { status, response } = resp.data;
    console.log(resp.data, "BAckendRes");

    if (status === "Sucess" || status === true) return response;
    else if (true || status === true) return resp.data?.data;
    else if (true) return resp.data;
    else if (status === 401) {
      throw new Error("Unauthorized");
    } else if (status === 403) {
      throw new Error("Forbidden");
    } else throw {};
  } catch (err) {
    console.log(err);
    console.log(action);
    return err;
  }
};

export const CALL_API_vedio_upload = async (action, method, payload) => {
  console.log(action, method, payload, "actionmethodpayload");
  const isMasterData = action.includes("master-data");
  try {
    const headers = {
      Tymeplusjwt: window.localStorage.getItem("token") || "",
    };

    if (!isMasterData) {
      headers["roleId"] = window.localStorage.getItem("selectedRoleId") || "";
    }
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers,
    });
    console.log(
      {
        method,
        url: `${SERVICE_URL}${action}`,
        data: payload,
        headers,
      },
      "respressswswpresp",
    );

    const { status } = resp?.data;
    console.log(status, "BAckendRes", resp?.data);

    if (status === true) return resp?.data;
    else if (status === 401) {
      throw new Error("Unauthorized");
    } else if (status === 403) {
      throw new Error("Forbidden");
    } else throw {};
  } catch (err) {
    console.log(err);
    console.log(action);
    return err;
  }
};
